exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#cus-icon-user-cog {\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    width: 0.44em;\r\n    height: 0.4em;\r\n    background-size: cover;\r\n}\r\n\r\n.cust-btn-edit-pwd {\r\n    min-width: 150px;\r\n}\r\n.alertsContainer {\r\n    right: 723px !important;\r\n    top: 166px !important;\r\n    z-index: 999;\r\n}\r\n.alertsContainer .alertsRow .messagepanel {\r\n    height: 50px !important;\r\n    padding: 5px !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main